import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { HowItWorks } from "@/components/HowItWorks";
import { Benefits } from "@/components/Benefits";
import { Testimonials } from "@/components/Testimonials";
import { DemoSection } from "@/components/DemoSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-transparent font-sans text-gray-200">
      <Navbar />
      <HeroSection />
      <HowItWorks />
      <Benefits />
      <Testimonials />
      <DemoSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
